"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indicator = exports.wrapper = void 0;

const wrapper = () => ({
  borderRadius: '8px !important'
});

exports.wrapper = wrapper;

const indicator = () => ({
  width: 127
});

exports.indicator = indicator;
//# sourceMappingURL=RatingChart.style.js.map